
// src/reducers/likes-reducer.js

import { mergeArray, deleteArray } from '../helpers/store'
import reduce from 'lodash/reduce'

import { 
  LIKE_DIARY,
  LIKE_DIARY_REQUESTED,
  LIKE_DIARY_COMPLETED,
  LIKE_DIARY_FAILED,
  LIKE_COMMENT,
  LIKE_COMMENT_REQUESTED,
  LIKE_COMMENT_COMPLETED,
  LIKE_COMMENT_FAILED,
  DELETE_LIKE,
  DELETE_LIKE_REQUESTED,
  DELETE_LIKE_COMPLETED,
  DELETE_LIKE_FAILED,
  FETCH_LIKE_CONFIG,
  FETCH_LIKE_CONFIG_REQUESTED,
  FETCH_LIKE_CONFIG_COMPLETED,
  FETCH_LIKE_CONFIG_FAILED,
} from '../actions/likes'

const initialState = {
  isFetching: false,
}

export default function likesReducer(state = initialState, action = {}) {
  switch(action.type) {
  case LIKE_DIARY_REQUESTED:
  case LIKE_COMMENT_REQUESTED:
  case FETCH_LIKE_CONFIG_REQUESTED:
  case DELETE_LIKE_REQUESTED:
    return Object.assign({}, state, {
      isFetching: true,
    })

  case LIKE_DIARY_FAILED:
  case LIKE_COMMENT_FAILED:
  case FETCH_LIKE_CONFIG_FAILED:
  case DELETE_LIKE_FAILED:
    return Object.assign({}, state, {
      isFetching: false,
    })

  case LIKE_DIARY_COMPLETED:
    return Object.assign({}, state, {
      isFetching: false,
    })

  case LIKE_COMMENT_COMPLETED:
    return Object.assign({}, state, {
      isFetching: false,
    })

  case FETCH_LIKE_CONFIG_COMPLETED: 
    return Object.assign({}, state, {
      isFetching: false,
      likeConfig: reduce(action.results,(r, item) => {
          r[item.like_type] = { icon: item.icon, label: item.label }
          return r },{})
      
    })

  case DELETE_LIKE_COMPLETED:
    return Object.assign({}, state, {
      isFetching: false,
    })

  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/likes-reducer.js